// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"165":"6bb37b7c","192":"1df9328e","389":"b5bfeed7","636":"39552abb","672":"de5992ff","940":"0556bb75","985":"5a1e2f31"}[chunkId] + ".chunk.js";
};